import {
  Box,
  Button,
  Dialog,
  Divider,
  IconButton,
  Slide,
  Typography,
} from '@material-ui/core';
import CalendarTodayOutlined from '@material-ui/icons/CalendarTodayOutlined';
import CheckRounded from '@material-ui/icons/CheckRounded';
import CloseIcon from '@material-ui/icons/Close';
import HelpOutline from '@material-ui/icons/HelpOutline';
import StarBorderRounded from '@material-ui/icons/StarBorderRounded';
import {
  BASE_S3,
  BUTTON_BACKGROUND_COLOR,
  BUTTON_TEXT_COLOR,
  COMPANY_COLORS,
} from 'config/consts';
import PropTypes from 'prop-types';
import React from 'react';

const generalColor = COMPANY_COLORS.general.general_color;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MONTHS = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

function formatDate(value) {
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return null;
  }
  return `${date.getDate()} de ${MONTHS[date.getMonth()]} de ${date.getFullYear()}`;
}

function InfoRow({ icon, children }) {
  return (
    <>
      <Box display="flex" alignItems="center" style={{ padding: '12px 0' }}>
        <Box style={{ color: generalColor, display: 'flex', marginRight: 12 }}>{icon}</Box>
        <Typography variant="body2">{children}</Typography>
      </Box>
      <Divider />
    </>
  );
}

InfoRow.propTypes = {
  icon: PropTypes.any,
  children: PropTypes.any,
};

function JourneyActivityModal({ action, onClose, onConfirm, formatarGanho }) {
  if (!action) {
    return null;
  }

  const validUntil = formatDate(action.end);
  const points = parseFloat(action.points) || 0;
  const done = !!action.hasDone;

  return (
    <Dialog
      open={!!action}
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="xs"
      PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}
    >
      <Box
        style={{
          height: 150,
          background: generalColor,
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          size="small"
          aria-label="fechar"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'rgba(255, 255, 255, 0.25)',
            color: '#fff',
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        {action.image ? (
          <img
            src={`${BASE_S3}/${action.image}`}
            alt={action.name}
            style={{
              width: 88,
              height: 88,
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid rgba(255, 255, 255, 0.7)',
            }}
          />
        ) : (
          <Box
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              border: '2px solid rgba(255, 255, 255, 0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <HelpOutline style={{ color: '#fff', fontSize: 36 }} />
          </Box>
        )}
      </Box>

      <Box style={{ padding: 24 }}>
        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
          {action.name}
        </Typography>
        {action.summary ? (
          <Typography variant="body2" style={{ color: '#8A8A8A', marginBottom: 16 }}>
            {action.summary}
          </Typography>
        ) : null}

        {validUntil ? (
          <InfoRow icon={<CalendarTodayOutlined fontSize="small" />}>
            Válido até {validUntil}
          </InfoRow>
        ) : null}

        {points > 0 && !done ? (
          <InfoRow icon={<StarBorderRounded fontSize="small" />}>
            Recompensa: <b>+{formatarGanho(points)}</b>
          </InfoRow>
        ) : null}

        {done ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{
              marginTop: 12,
              padding: '12px 0',
              borderRadius: 8,
              background: `${generalColor}1F`,
            }}
          >
            <CheckRounded style={{ color: generalColor, marginRight: 8 }} />
            <Typography
              variant="body2"
              style={{ color: generalColor, fontWeight: 'bold' }}
            >
              {points > 0
                ? `Concluído · +${formatarGanho(points)}`
                : 'Concluído'}
            </Typography>
          </Box>
        ) : (
        <Button
          fullWidth
          onClick={() => onConfirm(action)}
          style={{
            marginTop: 12,
            padding: '12px 0',
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 'bold',
            background: BUTTON_BACKGROUND_COLOR,
            color: BUTTON_TEXT_COLOR,
          }}
        >
          {action.click_me_label || 'Participar da atividade'}
        </Button>
        )}
      </Box>
    </Dialog>
  );
}

JourneyActivityModal.propTypes = {
  action: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  formatarGanho: PropTypes.func.isRequired,
};

export default JourneyActivityModal;
